export default __webpack_public_path__ + "static/media/s0_male.724d51a0.wav";